module.exports = function () {

    function initInterval ($this, countDownDate, element) {
        // Get today's date and time
        var now = new Date().getTime();
        $this.addClass('cc-active');

        // Find the distance between now and the count down date
        var distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        var days = ('0' + Math.floor(distance / (1000 * 60 * 60 * 24))).slice(-2);
        var hours = ('0' + Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).slice(-2);
        var minutes = ('0' + Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).slice(-2);
        var seconds = ('0' + Math.floor((distance % (1000 * 60)) / 1000)).slice(-2);

        // Output the result in an element with id="demo"
        element.html('<span>' + days + '</span>:<span>' + hours + '</span>:<span>' + minutes + '</span>:<span>' + seconds + '</span>');
    };

    $(document).ready(function () {
        $('.js-date-countdown').each(function() {
            var date = $(this).data('date-countdown');
            var countDownDate = new Date(date).getTime();
            var element = $(this);
            var $this = $(this);
            var now = new Date().getTime();
            var distance = countDownDate - now;

            if (distance < 0) {
                element.hide();
            } else {
                initInterval($this, countDownDate, element);
            }

            // Update the count down every 1 second
            var x = setInterval(function() {
                initInterval($this, countDownDate, element);

                var now = new Date().getTime();
                var distance = countDownDate - now;

                // If the count down is over, write some text
                if (distance < 0) {
                    clearInterval(x);
                    element.html('<span>00</span>:<span>00</span>:<span>00</span>:<span>00</span>');
                }
            }, 1000);
        });
    });
};
